export default {
  name: 'en',
  messages: {
    page_num: () =>
      'Please enter the correct number of pages. (integer 1-99999)',
    asc: (attr) => 'The ' + attr + ' must be in ascending order.',
    date_format: (field, [format]) =>
      `The ${field} must be in the format ${format}`,
    not_comma: () => 'The comma is not allowed',
    url: (field) => `The ${field} is not a valid URL`
  },
  names: {
    oauth: 'login provider',
    id: 'id',
    email: 'email',
    subject: 'subject',
    password: 'password',
    repeated: 'repeated password',
    policies: 'policies',
    reviewUrl: 'Review URL',
    date: 'date',
    title: 'title',
    authors: 'authors',
    translators: 'translators',
    publisher: 'publisher',
    newTag: 'tag',
    tag: 'tag',
    text: 'text',
    pageNum: 'page'
  }
}
